import React from "react"
import Search from "../../../gd-components/popover-menu/search/search"

type Props = {
    searchString    : string

    searchable?     : boolean

    onSearchChange  : callback
    onHidePopover   : callback
}

export default class SelectGenericPopoverSearch extends React.PureComponent<Props> {

    constructor(props: Props) {
        super(props);
    }

    render() {
        if (this.props.searchable) {
            return <Search searchString={this.props.searchString} onSearch={this.props.onSearchChange} onEscapePressed={this.props.onHidePopover}/>;
        } else {
            // still need to autofocus so keyboard work
            // @ts-ignore
            return <span className="hidden-search-input" tabIndex="0" />
        }
    }
}
